import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=31d37a5d"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"
import style0 from "./staff.vue?vue&type=style&index=0&id=31d37a5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports